/* RESPONSIBLE TEAM: team-automation-foundations */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class FinAiAgentSalesGetStartedRoute extends Route {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(FinAiAgentSalesGetStartedRoute, {
  overrideRenderTemplate: false,
});
